import { getLocale } from "../runtime";

const sv_apply = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Använd`
};

const apply = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_apply(inputs)
	return "apply";
};

export { apply as "apply" };